import styled from 'styled-components';
// import color from '../../configs/color';

const Wrapper = styled.div`
  cursor: pointer;
`;

export default Wrapper;
